import * as Scrivito from "scrivito";
import InPlaceEditingPlaceholder from "../../Components/InPlaceEditingPlaceholder";

const ButtonWidgetComponent = Scrivito.connect(({ widget, className = "" }) => {
  const target = widget.get("target");
  const noMargin = widget.get("noMargin");

  let text = target?.title() || widget.get("fallbacktitle");
  if (!text) {
    text = (
      <InPlaceEditingPlaceholder>
        Provide the button text in the widget properties.
      </InPlaceEditingPlaceholder>
    );
  }

  const classNames = ["btn", className];
  if (!noMargin) {
    classNames.push("mb-3");
  }
  const style = widget.get("style");
  const styleClass =
    !style || style.startsWith("btn") ? "bg-blue" : `bg-${widget.get("style")}`;
  classNames.push(styleClass);

  return (
    <Scrivito.LinkTag to={target} className={classNames.join(" ")}>
      {text}
    </Scrivito.LinkTag>
  );
});

Scrivito.provideComponent("ButtonWidget", ({ widget }) => {
  if (["start", "end", "center"].includes(widget.get("alignment"))) {
    return (
      <div className={`text-${widget.get("alignment")}`}>
        <ButtonWidgetComponent widget={widget} />
      </div>
    );
  }

  return <ButtonWidgetComponent widget={widget} className="w-100" />;
});
